import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

export const ComparisonSection = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    marginTop: '20px',
    marginBottom: '20px',
});

export const DocumentSelectionArea = styled('div')({
    display: 'flex',
    gap: '20px',
    marginBottom: '20px',

    '@media (max-width: 768px)': {
        flexDirection: 'column',
    },
});

export const FileInputContainer = styled('div')({
    flex: 1,
    border: '1px solid rgba(0, 0, 0, 0.1)',
    borderRadius: '5px',
    padding: '20px',
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    '& h3': {
        marginTop: 0,
        marginBottom: '5px',
        fontWeight: 500,
        textAlign: 'center',
    },
    '& p': {
        fontSize: '0.9rem',
        color: 'rgba(0, 0, 0, 0.6)',
        textAlign: 'center',
        marginBottom: '15px',
    },
});

export const FileNameDisplay = styled('div')({
    marginTop: '10px',
    fontSize: '0.9rem',
    color: 'rgba(0, 0, 0, 0.8)',
    fontStyle: 'italic',
    textAlign: 'center',
    wordBreak: 'break-word',
});

export const ButtonGroup = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    gap: '15px',
    margin: '20px 0',
});

export const ExtractionResults = styled('div')({
    marginTop: '20px',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    borderRadius: '5px',
    padding: '20px',
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
});

export const StyledButton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.secondary.main
}))

export const SummaryStats = styled('div')({
    display: 'flex',
    gap: '20px',
    marginBottom: '20px',
    flexWrap: 'wrap',
});

export const StatCard = styled('div')({
    flex: 1,
    minWidth: '150px',
    padding: '15px',
    borderRadius: '4px',
    backgroundColor: 'rgba(0, 0, 0, 0.02)',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
});

export const StatValue = styled('div')(({ theme }) => ({
    fontSize: '2rem',
    fontWeight: 500,
    color: theme.palette.secondary.main,
}));

export const StatLabel = styled('div')({
    fontSize: '0.9rem',
    color: 'rgba(0, 0, 0, 0.5)',
    marginTop: '5px',
});









